 
 import { login } from 'src/app/modules/auth/core/_requests';
import {useAppSelector} from 'src/redux/storeHooks'
import { isImpersonationSessionActive } from 'src/utils/impersonationTokens'

export const useUserHavingWriteAccess = () => {
   const {fetchedUserAccountData} = useAppSelector(
         (state) => state.userAccountData
       )
  
 const isUserHavingWriteAccess = () => {

 //  Case 1: Admin logged in as customer (parent_user_role exists) → grant full customer access
 //  When logged in as customer, treat as full customer access for all actions
    if (fetchedUserAccountData?.parent_user_role || isImpersonationSessionActive()) {
      return true;
    }
    
    // Case 2: Direct customer login (user_type === 'USER' and no parent_user_role) → grant full access
    if (fetchedUserAccountData?.user_type === "USER" && !fetchedUserAccountData?.parent_user_role) {
      return true
    }
    
    // Case 3: Direct admin login (no parent_user_role) → check permissions
    if((fetchedUserAccountData?.is_superuser || fetchedUserAccountData?.user_type === "SUPERADMIN") && !fetchedUserAccountData?.role ){
      return true
    }
    
    // Check role-based permissions for direct admin logins
    if (fetchedUserAccountData?.role?.customer_access === "WRITE" || fetchedUserAccountData?.role?.customer_access === "SUPERADMIN") {
      return true
    }

    return false
  }

  return { isUserHavingWriteAccess };
};